import { Injectable } from '@angular/core';
import { CookieService, CookieOptions } from 'ngx-cookie';
import { environment } from '@env/environment';
import { CryptoService } from '@services/crypto/crypto.service';
import { Router } from '@angular/router';
// import { CodeReusableService } from '@services/sharedServices/code-reusable.service';

@Injectable({
  providedIn: 'root'
})

export class StorageCookieService {
  [x: string]: any;
  private prefix = environment.app_name;
  // private cookieOptions = { expires: this.code.setExpiryDateTime('setYear', 1), storeUnencoded: true } as CookieOptions

  constructor(
    private cookie: CookieService,
    private crypto: CryptoService,
    private router: Router,
    // private code: CodeReusableService
  ) { }

  public setCookie(value, key) {
    key = `${this.prefix}-${key}`;
    this.cookie.put(key, value, environment.cookiesOptions);
  }

  public getCookie(key) {
    key = `${this.prefix}-${key}`;
    return this.cookie.get(key);
  }

  public setCookies(obj: Object, key) {
    key = `${this.prefix}-${key}`;
    this.cookie.putObject(key, obj, environment.cookiesOptions);
  }

  public getCookies(key) {
    key = `${this.prefix}-${key}`;
    return this.cookie.getObject(key);
  }

  public removeCookie(keys: Array<String>) {

    for (let key of keys) {
      const fullKey = `${this.prefix}-${key}`;
      this.cookie.remove(fullKey);
    }
  }

  public removeAll() {
    this.cookie.removeAll();
    this.router.navigate(['/account/login']);
  }

}
